export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  computed: {
    parsedDate: {
      get() {
        return 'DD/MM/AAAA'
      }
    }
  },
  created() {
    this.$eventHub.$emit('hide-appbar-shadow');
  }
};
